import { render, staticRenderFns } from "./dataBoardBox.vue?vue&type=template&id=77a0d787&scoped=true&"
import script from "./dataBoardBox.vue?vue&type=script&lang=js&"
export * from "./dataBoardBox.vue?vue&type=script&lang=js&"
import style0 from "./dataBoardBox.vue?vue&type=style&index=0&id=77a0d787&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a0d787",
  null
  
)

export default component.exports